import styled from '@emotion/styled';

import { Flex } from '@chakra-ui/react';

const Card = styled(Flex)``;

Card.defaultProps = {
  padding: 2,
  backgroundColor: 'background.default',
  boxShadow: 'lg',
  borderRadius: 'lg',
  overflow: 'hidden',
  flexShrink: 0,
};

Card.displayName = 'Card';
export default Card;
